<div class="widget form-group" [class.has-error]="control.invalid">
  <label [attr.for]="id" class="horizontal control-label">
      {{ schema?.hiddenTitle ? '' : schema.title }}
      <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <div *ngIf="!isArray" class="checkbox checkbox-single">
    <label class="horizontal control-label">
      <input [formControl]="control" [attr.name]="name" [attr.id]="id" [indeterminate]="control.value !== false && control.value !== true ? true :null" type="checkbox" [attr.disabled]="schema.readOnly" />
      <input *ngIf="schema.readOnly" [attr.name]="name" type="hidden" [formControl]="control" />
      {{ schema.description }}
    </label>
  </div>
  <ng-container *ngIf="isArray">
    <div *ngFor="let option of options" class="checkbox">
      <label class="horizontal control-label">
        <input [attr.name]="name"
          value="{{ option.value }}" type="checkbox"
          [attr.disabled]="schema.readOnly"
          (change)="checkToggle( option )"
          [checked]="isChecked( option.value )" />
        {{ option.label }}
      </label>
    </div>
    <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  </ng-container>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/checkbox.widget.html